export * from './string-replace-variables';
